import * as Types from '../constants/Types';
import Post from './../models/Post';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    post: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        post: new Post(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.POST_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.POST_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                posts: action.posts,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.POST_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, posts: [] };
        case Types.POST_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.POST_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { post: action.post, }
            };
        case Types.POST_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.POST_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.POST_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.POST_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.POST_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.POST_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.POST_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.POST_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.POST_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.POST_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.POST_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default:
            return state;
    }
}
